import axios from "axios";
import router from "../routes/router";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";

// You can use your own logic to set your local or production domain

const baseDomain = process.env.VUE_APP_BASE_URL_CORE_API;
const baseURL = `${baseDomain}`;

const userInfoLocalStorage = localStorage.getItem("token");

const API = axios.create({
  baseURL: baseURL,
  headers: {
    "project-suite": "Elearning",
    "community-name": process.env.VUE_APP_COMMUNITY_NAME,
  },
});

API.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token");
    const token = sessionStorage.getItem("token");

    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },

  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (
      // error.response.status === 401 ||
      // error.response.statusText == "Unauthorized" 
      error.response.data.code === 401 &&
      error.response.data.message === "Unauthorized"
    ) {
      window.App.$store.commit("auth/logout");
      window.localStorage.clear();
      Swal.fire({
        title: "Session Expired",
        text: "Your session has ended and for security reasons, we request you to login again",
        icon: "warning",
        confirmButtonColor: "#830c81",
        showConfirmButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          router.push({ name: "signin" });
        }
      });
    }

    return Promise.reject(error);
  }
);

export default API;
